import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DeliveryLogType } from '@dev/ee-api/ee-api-models';
import { BasicBadge, BasicBadgeVariantType } from '@dev/ee-components';

interface BadgeProps {
    variant: BasicBadgeVariantType;
    value: string;
}

const useBadgeProps = (status: string | DeliveryLogType): BadgeProps => {
    const { t } = useTranslation();
    switch (status) {
        case DeliveryLogType.ReadyToSend:
            return {
                variant: BasicBadgeVariantType.StatusName,
                value: t('readytosend'),
            };
        case DeliveryLogType.WaitingToRetry:
            return {
                variant: BasicBadgeVariantType.Cancelled,
                value: t('waitingtoretry'),
            };
        case DeliveryLogType.Sending:
            return {
                variant: BasicBadgeVariantType.InProgress,
                value: t('sending'),
            };
        case DeliveryLogType.Error:
            return {
                variant: BasicBadgeVariantType.Invalid,
                value: t('bounced'),
            };
        case DeliveryLogType.Sent:
            return {
                variant: BasicBadgeVariantType.StatusName,
                value: t('sent'),
            };
        case DeliveryLogType.Opened:
            return {
                variant: BasicBadgeVariantType.Active,
                value: t('opened'),
            };
        case DeliveryLogType.Clicked:
            return {
                variant: BasicBadgeVariantType.Active,
                value: t('clicked'),
            };
        case DeliveryLogType.Unsubscribed:
            return {
                variant: BasicBadgeVariantType.Paused,
                value: t('unsubscribed'),
            };
        case DeliveryLogType.AbuseReport:
            return {
                variant: BasicBadgeVariantType.Invalid,
                value: t('complained'),
            };
        case DeliveryLogType.Suppressed:
            return {
                variant: BasicBadgeVariantType.Disabled,
                value: t('suppressed'),
            };
        default:
            return {
                variant: BasicBadgeVariantType.Expired,
                value: '',
            };
    }
};

interface Props {
    status: string | DeliveryLogType;
    id: number | string;
}

const DeliveryLogBadge: FC<Props> = ({ status, id }: Props): JSX.Element => {
    const badgeProps = useBadgeProps(status);

    return (
        <BasicBadge
            key={`delivery-log-badge-${id}`}
            value={badgeProps.value}
            variant={badgeProps.variant}
            borderDisabled={true}
        />
    );
};

export default DeliveryLogBadge;
